
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { useNotificacaoEmailVariaveis } from '@/composables'
import { NotificacaoEmailVariavel } from '@/composables/useNotificacaoEmailVariaveis/types'

@Component
export default class VariaveisPanel extends Vue {
  @Prop({ default: '' }) tipo: string

  busca: string = ''
  carregando: boolean = false

  get variaveis(): NotificacaoEmailVariavel[] {
    return useNotificacaoEmailVariaveis.variaveisDoTipo(this.tipo)
  }

  get categoriasFiltradas() {
    const termo = this.busca.toLowerCase()

    const variaveisFiltradas = termo
      ? this.variaveis.filter(variavel => (
        variavel.label.toLowerCase().includes(termo) || variavel.token.toLowerCase().includes(termo)
      ))
      : this.variaveis

    const categorias = [...new Set(variaveisFiltradas.map(variavel => variavel.categoria))]

    return categorias.map(categoria => ({
      categoria,
      variaveis: variaveisFiltradas.filter(variavel => variavel.categoria === categoria),
    }))
  }

  @Watch('tipo', { immediate: true })
  async onTipoChange(tipo: string) {
    if (!tipo) {
      return
    }

    this.carregando = true
    await useNotificacaoEmailVariaveis.loadVariaveis(tipo)
    this.carregando = false
  }

  formatarToken(token: string): string {
    return `{{ p.${token} }}`
  }
}
